//Not using this

import React from 'react'
import BotResponseLayout from './BotResponseLayout'

function BotEventResponse({actionProvider}) {
    const buttonOptions = [
        {
            label: 'Current Events',
            action: actionProvider.handleCurrentEvents
        },
        {
            label: 'Past Events',
            action: actionProvider.handlePastEvents
        }
    ];
    const buttonStyle = {
        padding: "10px 15px",
        borderRadius: "8px",
        border: "none",
        backgroundColor: "rgb(0, 89, 164)",
        color: "#fff",
        fontSize: "16px",
        cursor: "pointer",
        transition: "background-color 0.3s, transform 0.2s",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    };
  return (
    <BotResponseLayout actionProvider={actionProvider}>
        <div
            style={{
                background: "#fff",
                maxWidth: "420px",
                width: "100%",
                fontFamily: "sans-serif",
                display: "flex",
                flexDirection: "column",
                gap: "12px",
            }}
        >
            {
                buttonOptions.map((obj, idx) => (
                    <button
                        onClick={obj.action}
                        style={buttonStyle}
                        onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor = "rgb(0, 100, 200)")
                        }
                        onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor = "rgb(0, 89, 164)")
                        }
                    >
                        {obj.label}
                    </button>
                ))
            }
        </div>
    </BotResponseLayout>
  )
}

export default BotEventResponse
